module.exports = {"632321100":"隆务镇","632321101":"保安镇","632321102":"多哇镇","632321200":"兰采乡","632321201":"双朋西乡","632321202":"扎毛乡","632321203":"黄乃亥乡","632321204":"曲库乎乡","632321205":"年都乎乡","632321207":"瓜什则乡","632321208":"加吾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632321.json
// module id = 3137
// module chunks = 0